import { z } from 'zod'

export const MonitoringEventParser = z.object({
  id: z.string(),
  tournamentId: z.string(),
  label: z.string(),
  tournament: z.string(),
  feedStatus: z.string(),
  healthy: z.boolean()
})

const Instance = z.object({
  instanceNumber: z.number(),
  address: z.string()
})

export const MonitoringEventsResponseParser = z.object({
  instances: z.array(Instance),
  events: z.array(MonitoringEventParser)
})

export type MonitoringEvent = z.infer<typeof MonitoringEventParser>
export type MonitoringEventsResponse = z.infer<typeof MonitoringEventsResponseParser>
